// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34l_N","right":"styles_right__3lu9N"};